import React, { ReactNode } from 'react';

import ListItem from '@gojob/ui-bits/List/Item';

export type ListItemProps = {
  children?: ReactNode;
};

const listItemRenderer = (props: ListItemProps) => <ListItem {...props} />;

export default listItemRenderer;
